import { Location } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';

@Component({
  selector: 'not-found',
  templateUrl: './not-found.component.html',
  standalone: false
})
export class PageNotFoundComponent implements OnDestroy  {
  public pageTitle: string = 'Page Not Found';

  constructor(public location: Location) { }

  goBack(): void {
    this.location.back();
  }

  public ngOnDestroy(): void {
    // No manual unsubscribe needed when using takeUntilDestroyed
  }
}
